import * as React from 'react';

const CancelCircleFilled32 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#CancelCircleFilled32__a)" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16 0C7.166 0 0 7.166 0 16s7.166 16 16 16 16-7.166 16-16S24.834 0 16 0Zm7.034 21.773-1.273 1.273L16 17.284l-5.761 5.762-1.273-1.273 5.762-5.761-5.762-5.761 1.273-1.273L16 14.74l5.761-5.762 1.273 1.273-5.762 5.761 5.762 5.761Z"
  }
)), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "CancelCircleFilled32__a" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h32v32H0z" }))));
CancelCircleFilled32.Size = 32;
CancelCircleFilled32.Title = "CancelCircleFilled";

export { CancelCircleFilled32 as default };
